var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('side-bar',{attrs:{"initial-total-amount":_vm.initialTotalAmount,"total-amount-of-month":_vm.totalAmountOfMonth}})}
var staticRenderFns = []

export { render, staticRenderFns }